module.exports = __webpack_public_path__ + "static/pattern-8be8159c94be976d88c318fceef49fab.png";